import { ENGLISH, ARABIC } from "../actions/localization.action";
import en from "../../localization/en";
import ar from "../../localization/ar";

export default (state = { ...en }, action) => {
  switch (action.type) {
    case ENGLISH:
      return { ...en };
    case ARABIC:
      return { ...ar };
    default:
      return state;
  }
};
